{
  "version": 1,
  "asset_id": "4b2f0c93-f4b2-4964-bed4-cd375035cf09",
  "project_id": "63ffb125-aed4-4f54-959a-0b116fa77b1d",
  "url": "/__l5e/assets-v1/4b2f0c93-f4b2-4964-bed4-cd375035cf09/bypass-revision-downsizing-es-1200.webp",
  "r2_key": "a/v1/63ffb125-aed4-4f54-959a-0b116fa77b1d/4b2f0c93-f4b2-4964-bed4-cd375035cf09/bypass-revision-downsizing-es-1200.webp",
  "original_filename": "bypass-revision-downsizing-es-1200.webp",
  "size": 92424,
  "content_type": "image/webp",
  "created_at": "2026-10-05T22:37:33Z"
}
